module.exports = __webpack_public_path__ + "static/patterns-sparkle.8e3cd96a.svg";